import { render, staticRenderFns } from "./Drones.vue?vue&type=template&id=8e294628&scoped=true&"
import script from "./Drones.vue?vue&type=script&lang=js&"
export * from "./Drones.vue?vue&type=script&lang=js&"
import style0 from "./Drones.vue?vue&type=style&index=0&id=8e294628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e294628",
  null
  
)

export default component.exports